// eslint-disable-next-line
import util from 'util';

import * as PortalApi from '../PortalApi';

export function queryMessages(successHandler, errorHandler, startTime, userVersion, smsTaskVersion,
                              accountId, accountVersion, locationId, locationVersion) {
  let query = PortalApi.makeQuery('/api/messages', { startTime, userVersion, smsTaskVersion,
                                                     accountId, accountVersion, locationId, locationVersion });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function getAllMessages(successHandler, errorHandler, startTime, endTime, userVersion, chatVersion, pageNumber, smsTaskVersion,
                                    accountId, accountVersion, locationId, locationVersion, scrollEnabled) {
let query = PortalApi.makeQuery('/api/messages/all', { startTime, endTime, userVersion, chatVersion, pageNumber, smsTaskVersion,
                         accountId, accountVersion, locationId, locationVersion, scrollEnabled, fromPortal:'yes' });
PortalApi.call(query, {}, successHandler, errorHandler);
}

export function getPureChats(successHandler, errorHandler, startTime, endTime, pageNumber, chatVersion) {
let query = PortalApi.makeQuery('/api/messages/pureChats', { startTime, endTime, chatVersion, pageNumber });
PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryActvityReport(successHandler, errorHandler, startTime, endTime, accountId, accountVersion, locationId, filterType, messageId,filterText,selectedMessages,matchWord, offset, messageGroupId) {
  let query = PortalApi.makeQuery('/api/messages/genpdf', { startTime, endTime, accountId, accountVersion, locationId, filterType, messageId,filterText,selectedMessages,matchWord, offset,messageGroupId});
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryCsvActvityReport(successHandler, errorHandler, startTime, endTime, accountId, accountVersion, locationId, filterType, messageId, offset,filterText,messageIds) {
  let query = PortalApi.makeQuery('/api/messages/gencsv', { startTime, endTime, accountId, accountVersion, locationId, filterType, messageId,filterText,messageIds, offset });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryCsvChatReport(successHandler, errorHandler, startTime, endTime, accountId, accountVersion, locationId, filterType, messageId, offset) {
  let query = PortalApi.makeQuery('/api/messages/genchatcsv', { startTime, endTime, accountId, accountVersion, locationId, filterType, messageId, offset });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryCsvSmsReport(
  successHandler,
  errorHandler,
  { startTime, endTime, offset }
) {
  let query = PortalApi.makeQuery("/api/smsTasks/genSmsCsv", {
    startTime,
    endTime,
    offset,
  });
  PortalApi.call(query, {}, successHandler, errorHandler);
}


export function generateChatExport(successHandler, errorHandler, chatId) {
  let query = PortalApi.makeQuery('/api/messages/getChatExport', { chatId });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryUserMessages(successHandler, errorHandler, startTime, version) {
  let query = PortalApi.makeQuery('/api/messages', { queryType: 'user', startTime, version });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryAccountMessages(successHandler, errorHandler, startTime, accountId, version) {
  let query = PortalApi.makeQuery('/api/messages', { queryType: 'account', startTime,
                                                     accountId, version });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryLocationMessages(successHandler, errorHandler, startTime, locationId, version) {
  let query = PortalApi.makeQuery('/api/messages', { queryType: 'location', startTime,
                                                     locationId, version });
  PortalApi.call(query, {}, successHandler, errorHandler);
}

export function queryContacts(successHandler, errorHandler) {
  PortalApi.call('/api/contacts', {}, successHandler, errorHandler);
}

/* Add a new contact */
export function addContact(successHandler, errorHandler, contact) {
  let form = PortalApi.makeForm({...contact});
  PortalApi.call('/api/contacts',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Update a contact */
export function updateContact(successHandler, errorHandler, contact) {
  let form = PortalApi.makeForm({...contact});
  PortalApi.call('/api/contacts/' + encodeURIComponent(contact.contactId),
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Add a contact method */
export function addContactMethod(successHandler, errorHandler, contactMethod) {
  let form = PortalApi.makeForm({...contactMethod});
  PortalApi.call('/api/contacts/' + encodeURIComponent(contactMethod.contactId) + '/methods',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Update a contact method */
export function updateContactMethod(successHandler, errorHandler, contactMethod) {
  let form = PortalApi.makeForm({...contactMethod});
  PortalApi.call('/api/contacts/' +
                 encodeURIComponent(contactMethod.contactId) +
                 '/methods/' +
                 encodeURIComponent(contactMethod.contactMethodId),
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Delete a contact method */
export function deleteContactMethod(successHandler, errorHandler, contactMethod) {
  PortalApi.call('/api/contacts/' +
                 encodeURIComponent(contactMethod.contactId) +
                 '/methods/' +
                 encodeURIComponent(contactMethod.contactMethodId),
                 { method : 'delete' },
                 successHandler, errorHandler);
}

/* Delete a contact  */
export function deleteContact(successHandler, errorHandler, contactId) {
  PortalApi.call('/api/contacts/' + encodeURIComponent(contactId),
                 { method : 'delete' },
                 successHandler, errorHandler);
}

/* Mark a message read for the current user */
export function readMessage(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/messages/' + encodeURIComponent(messageId) + '/read',
                 { method : 'post' },
                 successHandler, errorHandler);
}

/* Mark messages read for the current user */
export function bulkReadMessage(successHandler, errorHandler, messageIds, chatIds) {
  let form = PortalApi.makeForm({messageIds, chatIds});
  PortalApi.call('/api/messages/bulkread',
                 { method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Clear the message read date for the current user */
export function unreadMessage(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/messages/' + encodeURIComponent(messageId) + '/unread',
                 { method : 'post' },
                 successHandler, errorHandler);
}

/* Clear the message read date for the current user */
export function bulkUnreadMessage(successHandler, errorHandler, messageIds, chatIds) {
  let form = PortalApi.makeForm({messageIds, chatIds});
  PortalApi.call('/api/messages/bulkunread',
                 { method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Mark a message archive for the current user */
export function archiveMessage(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/messages/' + encodeURIComponent(messageId) + '/archive',
                 { method : 'post' },
                 successHandler, errorHandler);
}

export function bulkArchiveMessage(successHandler, errorHandler, messageIds, chatIds) {
  let form = PortalApi.makeForm({messageIds, chatIds});
  PortalApi.call('/api/messages/bulkarchive',
                 { method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Clear the message archive date for the current user */
export function unarchiveMessage(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/messages/' + encodeURIComponent(messageId) + '/unarchive',
                 { method : 'post' },
                 successHandler, errorHandler);
}

export function bulkUnarchiveMessage(successHandler, errorHandler, messageIds, chatIds) {
  let form = PortalApi.makeForm({messageIds, chatIds});
  PortalApi.call('/api/messages/bulkunarchive',
                 { method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Set the followup flag on a message */
export function changeFollowup(successHandler, errorHandler, messageId, followup) {
  let form = PortalApi.makeForm({followup});
  PortalApi.call('/api/messages/' + encodeURIComponent(messageId) + '/followup',
                 { method : 'post', body : form },
                 successHandler, errorHandler);
}

export function changeBulkFollowup(successHandler, errorHandler, messageIds, chatIds, followup) {
  let form = PortalApi.makeForm({messageIds, chatIds, followup});
  PortalApi.call('/api/messages/bulkfollowup',
                 { method : 'post', body: form },
                 successHandler, errorHandler);
}

/* Mark a chat read */
export function readChat(successHandler, errorHandler, taskId) {
  PortalApi.call('/api/smsTasks/' + encodeURIComponent(taskId) + '/read',
                 { method : 'post' },
                 successHandler, errorHandler);
}

/* Archive an SMS task (text thread) */
export function archiveSmsTask(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/smsTasks/archive/' + encodeURIComponent(messageId),
                 { method : 'post' },
                 successHandler, errorHandler);
}

/* Unarchive an SMS task (text thread) */
export function unarchiveSmsTask(successHandler, errorHandler, messageId) {
  PortalApi.call('/api/smsTasks/unarchive/' + encodeURIComponent(messageId),
                 { method : 'post' },
                 successHandler, errorHandler);
}

/* Set the hold calls flag on the current user */
export function changeHoldCalls(successHandler, errorHandler, holdCalls) {
  let form = PortalApi.makeForm({holdCalls});
  PortalApi.call('/api/me/holdCalls', { method : 'post', body : form },
                 successHandler, errorHandler);
}


/* Query the status message lists */
export function queryStatusLists(successHandler, errorHandler) {
  PortalApi.call('/api/statusLists', {},
                 successHandler, errorHandler);
}

/*
 * Add a new status
 */
export function addStatus(successHandler, errorHandler, status, override) {
  let contactNumbers = status.contacts
                             .filter(contact => Boolean(contact.contactData))
                             .map(contact => contact.contactData);
  let exceptions;
  if (status.takingCalls) {
    exceptions = status.exceptions
                       .filter(exception => Boolean(exception.exceptionName) &&
                                          exception.disposition === 'REJECT')
                       .map(exception => exception.exceptionName);
  } else {
    exceptions = status.exceptions
                       .filter(exception => Boolean(exception.exceptionName) &&
                                          exception.disposition === 'ACCEPT')
                       .map(exception => exception.exceptionName);
  }
  let form = PortalApi.makeForm({statusName: status.statusName,
                                 startTime: status.startTime !== null ? status.startTime.toISOString() : null,
                                 endTime: status.endTime !== null ? status.endTime.toISOString() : null,
                                 override: override ? 'Y' : 'N',
                                 takingCalls : status.takingCalls ? 'Y' : 'N',
                                 saved : status.saved ? 'Y' : 'N',
                                 durationStatusListId : status.durationStatusListId,
                                 messageStatusListId : status.messageStatusListId,
                                 instructionStatusListId : status.instructionStatusListId,
                                 instructions : status.instructions,
                                 contactNumbers : JSON.stringify(contactNumbers),
                                 exceptions : JSON.stringify(exceptions)});
  PortalApi.call('/api/statuses',
                 {method: 'post', body : form},
                 successHandler, errorHandler);
}

/*
 * Update an existing status
 */
export function updateStatus(successHandler, errorHandler, status, override) {
  let contactNumbers = status.contacts
                             .filter(contact => Boolean(contact.contactData))
                             .map(contact => contact.contactData);
  let exceptions;
  if (status.takingCalls) {
    exceptions = status.exceptions
                       .filter(exception => Boolean(exception.exceptionName) &&
                                          exception.disposition === 'REJECT')
                       .map(exception => exception.exceptionName);
  } else {
    exceptions = status.exceptions
                       .filter(exception => Boolean(exception.exceptionName) &&
                                          exception.disposition === 'ACCEPT')
                       .map(exception => exception.exceptionName);
  }
  if(typeof(status.startTime) === 'string'){status.startTime = new Date(status.startTime)}
  if(typeof(status.endTime) === 'string'){status.endTime = new Date(status.endTime)}
  let form = PortalApi.makeForm({statusName: status.statusName,
                                 startTime: status.startTime ? status.startTime.toISOString() : null,
                                 endTime: status.endTime ? status.endTime.toISOString() : null,
                                 takingCalls : status.takingCalls ? 'Y' : 'N',
                                 saved : status.saved ? 'Y' : 'N',
                                 durationStatusListId : status.durationStatusListId,
                                 messageStatusListId : status.messageStatusListId,
                                 instructionStatusListId : status.instructionStatusListId,
                                 instructions : status.instructions,
                                 statusScheduleId: status.scheduleId,
                                 contactNumbers : JSON.stringify(contactNumbers),
                                 exceptions : JSON.stringify(exceptions)});
  PortalApi.call('/api/statuses/' + encodeURIComponent(status.statusId),
                 {method: 'post', body : form},
                 successHandler, errorHandler);
}

/*
 * Add a schedule to a saved status
 */
export function scheduleStatus(successHandler, errorHandler, statusId, startTime, endTime, override) {
  let form = PortalApi.makeForm({ startTime: startTime.toISOString(),
                                  endTime: endTime !== null ? endTime.toISOString() : null,
                                  override : override ? 'Y' : 'N'});  
  PortalApi.call('/api/statuses/' + encodeURIComponent(statusId) + '/schedules',
                 {method: 'post', body: form},
                 successHandler, errorHandler);
}

/*
 * Cancel a schedule
 */
export function cancelStatus(successHandler, errorHandler, statusId,
                             statusScheduleId) {
  PortalApi.call('/api/statuses/' + encodeURIComponent(statusId) + '/schedules/' +
                 encodeURIComponent(statusScheduleId),
                 {method: 'delete'},
                 successHandler, errorHandler);
}

/*
 * Move a status to the saved list
 */
export function saveStatus(successHandler, errorHandler, statusId) {
  let form = 'empty=0';
  PortalApi.call('/api/statuses/' + encodeURIComponent(statusId) + '/save',
                 {method: 'post', body : form },
                 successHandler, errorHandler);
}

/*
 * Delete a saved status
 */
export function removeStatus(successHandler, errorHandler, statusId) {
  PortalApi.call('/api/statuses/' + encodeURIComponent(statusId),
                 {method: 'delete'},
                 successHandler, errorHandler);
}

/*
 * Query SMS tasks
 */
export function querySmsTasks(successHandler, errorHandler, startTime, endTime, pageNumber, version) {
  let query = PortalApi.makeQuery('/api/smsTasks', { startTime, endTime, pageNumber, version });
  PortalApi.call(query, {}, successHandler, errorHandler);  
}

/*
 * Send an SMS Text
 */
export function sendText(successHandler, errorHandler, sourcePhoneNumberId, destinationPhoneNumber, message) {
  let form = PortalApi.makeForm({sourcePhoneNumberId, destinationPhoneNumber, message});
  PortalApi.call('/api/smsTasks',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

/*
 * Submit an assist request
 */
export function submitAssistRequest(successHandler, errorHandler, locationId, requestType,
                                    referenceTaskId, referenceMessageId, outboundPhoneNumberId, request) {
  let form = PortalApi.makeForm({locationId, requestType, request, referenceTaskId,
                                 referenceMessageId, outboundPhoneNumberId});
  PortalApi.call('/api/me/assistRequest',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}


/*
 * Query available transfer services
 */
export function queryTransferServices(successHandler, errorHandler) {
  PortalApi.call('/api/transfers/services', {}, successHandler, errorHandler);  
}

/*
 * Create a transfer service link
 */
export function createTransferLink(successHandler, errorHandler, transferServiceId, token,apiKey) {
  let form = PortalApi.makeForm({transferServiceId, token,apiKey});
  
  PortalApi.call('/api/transfers/links',
                 { method : 'post', body: form },
                 successHandler, errorHandler);  
}

/*
 * Update a transfer link
 */
export function updateTransferLink(successHandler, errorHandler, transferServiceId, token,apiKey) {
  let form = PortalApi.makeForm({token,apiKey});
  
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferServiceId),
                 { method : 'post', body: form },
                 successHandler, errorHandler);  
}

/*
 * delete a transfer link
 */
export function deleteTransferLink(successHandler, errorHandler, transferLinkId) {
  PortalApi.call('/api/transfers/links/' + transferLinkId,
                 { method : 'delete' },
                 successHandler, errorHandler);  
}

/*
 * Create a transfer link rule
*/
export function createTransferLinkRule(successHandler, errorHandler, transferLinkId,
                                       matchAll, deny, accountId, phoneNumberId, messageCategoryId, messageGroupId) {
  let form = PortalApi.makeForm({matchAll, deny, accountId, phoneNumberId, messageCategoryId, messageGroupId});
  
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferLinkId) + "/rules",
                 { method : 'post', body: form },
                 successHandler, errorHandler);  
}

/*
 * Delete transfer link rule
*/
export function deleteTransferLinkRule(successHandler, errorHandler, transferLinkId, transferRuleId) {
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferLinkId) + "/rules/" +
                 encodeURIComponent(transferRuleId),
                 { method : 'delete' },
                 successHandler, errorHandler);  
}

/*
 * Delete all transfer link rules
*/
export function deleteAllTransferLinkRules(successHandler, errorHandler, transferLinkId, transferRuleId) {
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferLinkId) + "/rules",
                 { method : 'delete' },
                 successHandler, errorHandler);  
}

/*
 * Manually transfer a delivery to a transfer link
 */
export function manualTransfer(successHandler, errorHandler, transferLinkId, deliveryId) {
  let form = PortalApi.makeForm({deliveryId});
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferLinkId) + "/transfers",
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}

/*
 * Backfill a transfer link
 */
export function backfillTransferLink(successHandler, errorHandler, transferLinkId) {
  let form = PortalApi.makeForm({daysBack: ''});
  PortalApi.call('/api/transfers/links/' + encodeURIComponent(transferLinkId) + "/backfill",
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}


/*
 * Backfill a transfer link
 */
export function sendVerificationCodeEmail(successHandler, errorHandler, email,phone,code) {
  let form = PortalApi.makeForm({email: email,code:code,phone:phone});
  PortalApi.call('/api/transfers/links/verify',
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}

/* get block numbers by account */
export function getBlockedNumbersByAccount(successHandler, errorHandler, accountId) {
  let url = '/api/blockNumbers/?accountId='+encodeURIComponent(accountId);
  PortalApi.call(url, {}, successHandler, errorHandler, 'List Block Number');
}

/*
 * block a phone number
 */
export function blockPhoneNumber(successHandler, errorHandler, accountId,phoneNumber, name=undefined, company=undefined) {
  let url = '/api/blockNumbers/';
 
  let form = PortalApi.makeForm({ accountId:accountId, phoneNumber:phoneNumber,name, company });
  PortalApi.call(url, { method: 'post', body : form }, successHandler, errorHandler, 'Block Number');
}
/**
 * Edit a blocked phone number
 */
export function editBlockPhoneNumber(
  successHandler,
  errorHandler,
  accountId,
  phoneNumber,
  entryId,
  name = undefined,
  company = undefined
) {
  let url = "/api/editBlockNumbers/";

  let form = PortalApi.makeForm({
    entryId,
    accountId,
    phoneNumber,
    name,
    company,
  });
  PortalApi.call(
    url,
    { method: "post", body: form },
    successHandler,
    errorHandler,
    "Edit Block Number"
  );
}
/*
* unblock a phone number
*/
export function unblockPhoneNumber(successHandler, errorHandler, accountId,existingNumber) {
  let url = '/api/blockNumbers/unblock';
  var data = { accountId:accountId, existingNumber:existingNumber};
  let form = PortalApi.makeForm(data);
  PortalApi.call(url, { method: 'post', body : form }, successHandler, errorHandler, 'Unblock Number');
}

export function getDownloadUrl(successHandler, errorHandler, audioKey) {
  let url = '/api/media/link/' + audioKey;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Download URL');
}

/*
* create conditional call forwarding
*/
export function createConditionalCallForwarding(successHandler, errorHandler, phoneNumberId,patchNumber,handling,forwardToAgent) {
  let url = '/api/conditionalCallForwarding';
  var data = { phoneNumberId, patchNumber, handling, forwardToAgent };
  let form = PortalApi.makeForm(data);
  PortalApi.call(url, { method: 'post', body : form }, successHandler, errorHandler, 'Conditional call forwarding');
}

export function markChatRead(successHandler, errorHandler, chatId, clear) {
  let form = PortalApi.makeForm({clear});
  PortalApi.call('/api/messages/' + encodeURIComponent(chatId) + "/chatread",
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}

export function markChatArchived(successHandler, errorHandler, chatId, clear) {
  let form = PortalApi.makeForm({clear});
  PortalApi.call('/api/messages/' + encodeURIComponent(chatId) + "/chatarchive",
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}

export function markChatFollowup(successHandler, errorHandler, chatId, followup) {
  let form = PortalApi.makeForm({followup});
  PortalApi.call('/api/messages/' + encodeURIComponent(chatId) + "/chatfollowUp",
                 { method : 'post', body : form },
                 successHandler, errorHandler);  
}

export function importContacts(successHandler, errorHandler, transferId) {
  PortalApi.call('/api/transfers/importContacts/' + encodeURIComponent(transferId), {},
                  successHandler, errorHandler);
}

export function getVipCallersByAccount(successHandler, errorHandler, accountId) {
  let url = '/api/vipCallers/?accountId='+encodeURIComponent(accountId);
  PortalApi.call(url, {}, successHandler, errorHandler, 'List Vip Callers');
}

export function createVipContact(successHandler, errorHandler, accountId, name, company, phoneNumber) {
  let form = PortalApi.makeForm({accountId, name, company, phoneNumber});
  PortalApi.call('/api/vipCallers/create',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function updateVipContact(successHandler, errorHandler, accountId, name, company, phoneNumber, vipCallerId) {
  let form = PortalApi.makeForm({accountId, name, company, phoneNumber, vipCallerId});
  PortalApi.call('/api/vipCallers/update',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function deleteVipContact(successHandler, errorHandler, vipCallerId) {
  let form = PortalApi.makeForm({vipCallerId});
  console.log(form);
  PortalApi.call('/api/vipCallers/delete',
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function updateVipForwardingNumber(successHandler, errorHandler, accountId, vipForwardingNumber) {
  let url = '/api/accounts/updateVipNumber';
  var data = { accountId, vipForwardingNumber };
  let form = PortalApi.makeForm(data);
  PortalApi.call(url, { method: 'post', body : form }, successHandler, errorHandler, 'Update VIP Forwarding Number');
}

export function getReportFiles(successHandler, errorHandler) {
  let url = '/api/messages/getReportFiles';
  PortalApi.call(url, {}, successHandler, errorHandler, 'Report Files');
}

export function getSignedUrl(fileId, successHandler, errorHandler) {
  let url = `/api/messages/getDownloadLink/${fileId}`;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Signed URL for S3 files');
}

// Call Handling APIs
export function getCallHandling(accountId, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}`;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Get Call Handling');
}

export function updateGreeting(accountId, greeting, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/greeting`;
  let form = PortalApi.makeForm({ greeting });
  PortalApi.call(url, { method: 'post', body: form }, successHandler, errorHandler, 'Update Greeting');
}

export function updateKnowledgeBase(accountId, knowledgeBase, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/knowledge`;
  let form = PortalApi.makeForm({ knowledgeBase });
  PortalApi.call(url, { method: 'post', body: form }, successHandler, errorHandler, 'Update Knowledge Base');
}

export function updateFaq(accountId, faq, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/faq`;
  let form = PortalApi.makeForm({ faq });
  PortalApi.call(url, { method: 'post', body: form }, successHandler, errorHandler, 'Update FAQ');
}

export function updateBotDelay(accountId, botDelay, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/botdelay`;
  let form = PortalApi.makeForm({ botDelay });
  PortalApi.call(url, { method: 'post', body: form }, successHandler, errorHandler, 'Update Bot Delay');
}

export function getPhoneNumbers(accountId, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/phonenumbers`;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Get Phone Numbers');
}

export function allocatePhoneNumber(accountId, areaCode, successHandler, errorHandler) {
  let url = `/api/callhandling/${accountId}/allocateNumber`;
  let form = PortalApi.makeForm({ areaCode });
  PortalApi.call(url, { method: 'post', body: form }, successHandler, errorHandler, 'Allocate Phone Number');
}

/* Call Forms API */
export function getCallForm(accountId, successHandler, errorHandler) {
  let url = `/api/forms/${accountId}`;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Get Call Form');
}

export function createFormVersion(sourceFormVersionId, successHandler, errorHandler) {
  let url = `/api/formVersions`;
  let body = JSON.stringify({ sourceFormVersionId });
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Create Form Version');
}

export function activateFormVersion(formId, formVersionId, successHandler, errorHandler) {
  let url = `/api/formVersions/activate`;
  let body = JSON.stringify({ formId, formVersionId });
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Activate Form Version');
}

export function createFormField(field, successHandler, errorHandler) {
  let url = `/api/formFields`;
  let body = JSON.stringify(field);
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Create Form Field');
}

export function updateFormField(formFieldId, field, successHandler, errorHandler) {
  let url = `/api/formFields/${formFieldId}`;
  let body = JSON.stringify(field);
  PortalApi.call(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Update Form Field');
}

export function updateManyFormFields(fields, successHandler, errorHandler) {
  let url = `/api/formFields/updateFormFields`;
  let body = JSON.stringify(fields);
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Update Form Fields');
}

export function deleteFormField(formFieldId, successHandler, errorHandler) {
  let url = `/api/formFields/${formFieldId}`;
  PortalApi.call(url, { method: 'DELETE' }, successHandler, errorHandler, 'Delete Form Field');
}

export function moveFormField(formFieldId, beforeFormFieldId, successHandler, errorHandler) {
  let url = `/api/formFields/move`;
  let body = JSON.stringify({ formFieldId, beforeFormFieldId });
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Move Form Field');
}

/* AI Actions APIs */
export function getAIActions(accountId, successHandler, errorHandler) {
  let url = `/api/aiActions/${accountId}`;
  PortalApi.call(url, {}, successHandler, errorHandler, 'Get AI Actions');
}

export function createAIAction(aiAction, successHandler, errorHandler) {
  let url = `/api/aiActions`;
  let body = JSON.stringify(aiAction);
  PortalApi.call(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Create AI Action');
}

export function updateAIAction(aiAction, successHandler, errorHandler) {
  let url = `/api/aiActions`;
  let body = JSON.stringify(aiAction);
  PortalApi.call(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body }, successHandler, errorHandler, 'Update AI Action');
}

export function toggleWarmTransfer(accountId, successHandler, errorHandler) {
  let url = `/api/accounts/${accountId}/warmTransferToggle`;
  PortalApi.call(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' } }, successHandler, errorHandler, 'Toggle Warm Transfer');
}